import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class ReviewComponent implements OnInit {

  reviews = [
    { user: 'Arindam Guha', comment: 'Had a wonderful experience.Ordered Food packets for Housewarming party.',image:'assets/images/happy.png',rating:5},
    { user: 'Arnab Mukherjee', comment: 'Awesome food and good service in my brothers wedding!' ,image:'assets/images/happy1.png',rating:5},
    { user: 'Bidesh Sarkar', comment: 'Excellent Food, Good in Quantity, On Time Service, Nominal Pricing too.',image:'assets/images/happy3.png',rating:5 }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
